//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../no/Section.js";
let d=[[[0,"DistanceTolerance",1,1],[1,"OffsetCurves",0,"Section",1],[0,"OffsetDistance",1,1],[0,"OffsetViewDirection",1,"Direction",1],[0,"ReverseDirection",1,1]],[[["numReverseFlags","allReverseDirectionFlags"],"GetAllReverseDirectionFlags",{},0,1],[["allReverseDirectionFlags"],"SetAllReverseDirectionFlags",{},1,1]],[]];
SPLM.Tooling.OffsetCurve3DBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.OffsetCurve3DBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;